import apiClient from '../apiClient';
import { apiBaseUrl } from '../../config';

export const getFiscalAccount = async (accountId) => {
    return apiClient.get(`${apiBaseUrl}/fiscal/fis_account/${accountId}`, {})
    .then(response => { return response });
}

export const createFiscalAccount = async (connectionId) => {
    return apiClient.post(`${apiBaseUrl}/fiscal/${connectionId}`, {})
    .then(response => { return response });
}

export const getTaxStatusList = async (accountId) => {
    return apiClient.get(`${apiBaseUrl}/fiscal-documents/tax/status/${accountId}`, {})
    .then(response => { return response });
}

export const getTaxStatus = async (accountId, taxStatusId) => {
    return apiClient.get(`${apiBaseUrl}/fiscal/tax/status/get/${accountId}/${taxStatusId}`, {})
    .then(response => { return response });
}

export const getTaxComplianceList = async (accountId) => {
    return apiClient.get(`${apiBaseUrl}/fiscal-documents/tax/compliance/${accountId}`, {})
    .then(response => { return response });
}

export const getTaxCompliance = async (accountId, taxComplianceId) => {
    return apiClient.get(`${apiBaseUrl}/fiscal/tax/compliance/get/${accountId}/${taxComplianceId}`, {})
    .then(response => { return response });
}

export const updateTaxStatus = async (accountId) => {
    return apiClient.post(`${apiBaseUrl}/fiscal-documents/tax/status/${accountId}`, {})
    .then(response => { return response });
}

export const updateTaxCompliance = async (accountId) => {
    return apiClient.post(`${apiBaseUrl}/fiscal-documents/tax/compliance/${accountId}`, {})
    .then(response => { return response });
}

export const updateTaxStatusFrequency = async (accountId, data) => {
    return apiClient.put(`${apiBaseUrl}/fiscal/tax/status/update/frequency/${accountId}`, data)
    .then(response => { return response });
}

export const updateTaxComplianceFrequency = async (accountId, data) => {
    return apiClient.put(`${apiBaseUrl}/fiscal/tax/compliance/update/frequency/${accountId}`, data)
    .then(response => { return response });
}

export const getAccountRegimes = async (accountId) => {
    return apiClient.get(`${apiBaseUrl}/fiscal/taxpayer/regimes/get/admin/${accountId}`)
    .then(response => { return response });
}